<template>

<div id="HearingCalibrationSpeaker">

    <div class="HearingTest-test--title">

      <span><icon name="volume-up"></icon></span>
    <span>کالیبراسیون صوتی</span>
    </div>

    <div>
        <div v-show="curCalibration == 'first'" class="HearingTest-test--text">
            <strong>بر روی گزینه اجرا کلیک کنید</strong>
            <br>
            <span>صدا را کم و زیاد کنید تا جاییکه احساس کنید سطح شنیداری صدا برای شما <strong>راحت و مناسب</strong> است.</span>
        </div>
        <div v-show="curCalibration == 'second'" class="HearingTest-test--text" >
            <strong>بر روی گزینه اجرا کلیک کنید</strong>
            <br> صدا را تنظیم کنید تا جاییکه <strong>به سختی</strong> بتوانید صدا را بشنوید.
            <br>در مورد تشخیص مواردی که گفته میشود نگران نباشید، لطفا فقط تمرکز کنید که آیا صدایی وجود دارد یا نه؟
      </div>
    </div>

    <div id="firstCalibration" class="HearingTest-test--calibrationContainer clearfix" v-show="curCalibration == 'first'">

        <v-layout row wrap>
            <v-flex xs12 text-xs-center>
                <v-layout row wrap>
                    <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
                        <div class="HearingTest-test--volumeContainer" v-show="showVolumeAdjusters" @click="lowerVolume(5,6)">
        <div class="HearingTest-test--volumeControlContainer">
          <div class="HearingTest-test--volumeControl">
              <icon name="minus-circle"></icon>
          </div>
        </div>
        <div class="HearingTest-test--volumeButton ng-binding">ملایمتر</div>
      </div>
                    </v-flex>
                    <v-flex sm4 xs6 text-xs-center  class="play-volume">
                        <div class="HearingTest-test--spinner">
                            <div class="HearingTest-test--playButtonContainer" v-bind:class="{'Active': showVolumeAdjusters}">
                                <div class="HearingTest-test--playButton" v-show="!showVolumeAdjusters" @click="audioCalibrationPlay()">
                                    <span class="play-icon"><icon name="play"></icon></span>
                                </div>
                                <div class="HearingTest-test--volume" v-show="showVolumeAdjusters" >{{ currVolShow() }}%</div>
                            </div>
                            <div class="HearingTest-test--spinnerBar" v-bind:class="{'Active': showVolumeAdjusters}"></div>
                        </div>
                    </v-flex>
                    <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
                        <div class="HearingTest-test--volumeContainer" v-show="showVolumeAdjusters" @click="raiseVolume(5,96)">
                            <div class="HearingTest-test--volumeControlContainer">
                                <div class="HearingTest-test--volumeControl">
                                    <icon name="plus-circle"></icon>
                                </div>
                            </div>
                            <div class="HearingTest-test--volumeButton">بلندتر</div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12 text-xs-center>
                <div class="HearingTest-test--textButton" v-show="showVolumeAdjusters" @click="nextCalibrationPart()"><span>ادامه</span>  &gt;</div>
            </v-flex>
        </v-layout>

    </div>

    <div id="secondCalibration" class="HearingTest-test--calibrationContainer clearfix" v-show="curCalibration == 'second'">

        <v-layout row wrap>
            <v-flex xs12 text-xs-center>
                <v-layout row wrap>
                    <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
                        <div class="HearingTest-test--volumeContainer" v-show="showVolumeAdjusters" @click="lowerVolume(1,1)">
              <div class="HearingTest-test--volumeControlContainer">
                  <div class="HearingTest-test--volumeControl">
                      <icon name="minus-circle"></icon>
                  </div>
              </div>
              <div class="HearingTest-test--volumeButton ng-binding">ملایمتر</div>
          </div>
                    </v-flex>

                    <v-flex sm4 xs6 text-xs-center  class="play-volume">
                        <div class="HearingTest-test--spinner">
                            <div class="HearingTest-test--playButtonContainer" v-bind:class="{'Active': showVolumeAdjusters}">
                                <div class="HearingTest-test--playButton" v-show="!showVolumeAdjusters" @click="audioCalibrationPlay()">
                                    <span class="play-icon"><icon name="play"></icon></span>
                                </div>
                                <div class="HearingTest-test--volume" v-show="showVolumeAdjusters" >{{ currVolShow() }}%</div>
                            </div>
                            <div class="HearingTest-test--spinnerBar" v-bind:class="{'Active': showVolumeAdjusters}"></div>
                        </div>
                    </v-flex>

                    <v-flex sm4 xs6 text-xs-center v-show="showVolumeAdjusters" >
                        <div class="HearingTest-test--volumeContainer" v-show="showVolumeAdjusters" @click="raiseVolume(1,MaxVol)">
                            <div class="HearingTest-test--volumeControlContainer">
                                <div class="HearingTest-test--volumeControl">
                                    <icon name="plus-circle"></icon>
                                </div>
                            </div>
                            <div class="HearingTest-test--volumeButton">بلندتر</div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 text-xs-center>
                <div class="HearingTest-test--textButton" v-show="showVolumeAdjusters" @click="saveCalibrations()"><span>ادامه   &gt;</span></div>
            </v-flex>
        </v-layout>




      </div>

</div>

</template>

<script>
  import continuousDiscourse_RL from '@/assets/sounds/calibration/continuousDiscourse_RL.mp3';
export default {
    name: 'HearingCalibrationSpeaker',

    components: {

    },
  mounted() {
      //console.log(window.calibrationType);
  },
  data () {

    return {
        curCalibration:"first",
        audio: new Audio(continuousDiscourse_RL),
        showVolumeAdjusters: false,
        currVol : 40,
        MaxVol:0,
        speakerAnswer : {
            type:'speaker',
            data:[]
        },
    }
  },
    /*watch:{
        currVol: function (val) {
            this.currVol = parseFloat(val.toFixed(2));
        }
    },*/
    methods:{
        audioCalibrationPlay(){
            this.showVolumeAdjusters = true;
            this.audio.volume = this.currVol / 100;
            this.audio.addEventListener('ended', function() {
                this.currentTime = 0;
                this.play();
            }, false);
            this.audio.play();
        },
        lowerVolume(vol,lower){

            if(this.currVol > lower)
            this.audio.volume = ((this.currVol -= vol) / 100).toFixed(2);

            //console.log('lowerVolume',this.currVol ,this.audio.volume);
        },
        raiseVolume(vol,riser){
            if(this.curCalibration === "second")
                riser = riser >= 10 ? riser-4 : riser / 2 ;
            if(this.currVol < riser)
            this.audio.volume =  ((this.currVol += vol) / 100).toFixed(2);
            //console.log('raiseVolume',this.currVol ,this.audio.volume);
        },
        nextCalibrationPart(){
            this.audio.pause();
            this.audio.currentTime = 0;
            this.speakerAnswer.data['first'] = this.currVol;
            this.MaxVol = this.audio.volume * 100;
            this.currVol =  Math.ceil(this.audio.volume*50);
            this.audio.volume =  (this.currVol / 100).toFixed(2);
            this.showVolumeAdjusters = false;
            this.curCalibration = "second";

          //console.log("next");
        },
        saveCalibrations(){
            this.audio.pause();
            this.audio.currentTime = 0;
            this.speakerAnswer.data['second'] = this.currVol;
            window.calibrationAnswers = this.speakerAnswer;
            //console.log("save calibrationAnswers Speaker",window.calibrationAnswers);
            this.$parent.$router.replace('/pure_tone_test');
        },
        currVolShow(){
            return parseInt(this.currVol);
        }

    }
}
</script>

<style scoped>
  #HearingCalibrationSpeaker{
    margin: 40px;
      padding: 0 10px 100px;
  }
  .play-volume{
      position: relative;
      width: 130px;
      height: 130px;
  }
   .HearingTest-test--title {
     text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 54px;
    line-height: 52px;
    color: #00b7c6;
  }
   .HearingTest-test--text {
     text-align: center;
     margin-bottom: 20px;
     font-weight: normal;
     font-style: normal;
     font-size: 16px;
     line-height: 22px;
     color: #000;
   }
   .HearingTest-test--calibrationContainer {
     text-align: center;
     display: table;
     margin: 0 auto;
   }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner {
      text-align: center;
      width: 120px;
      height: 120px;
      border: 15px solid #fff;
      border-radius: 120px;
      -webkit-box-shadow: 0px 0px 1px;
      box-shadow: 0px 0px 1px;
      margin: 0 auto;
  }
  @media (max-width: 599px){
      .HearingTest-test--calibrationContainer .HearingTest-test--spinner{

          margin: 65px auto 0;
          position: absolute;
      }
      .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
          text-align: center;
          width: 100px;
          margin: 0 auto 0;
      }
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer .HearingTest-test--playButton .play-icon {
      text-align: center;
    color: #fff;
    position: absolute;
    font-size: 40px;
    left: 50%;
      margin-left: -12px;
      top: 50%;
      margin-top: -20px;
  }
   .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer {
     text-align: center;
     position: absolute;
     z-index: 5;
     width: 100px;
     height: 100px;
     margin-right: -5px;
     margin-top: -5px;
     background-color: #00b7c6;
     border-radius: 120px;
     cursor: pointer;
     box-shadow: 0px 0px 1px;
     box-sizing: content-box;
     -webkit-box-sizing: content-box;
     -moz-box-sizing: content-box;
   }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer.Active {
      background-color: #b5be00;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer.Active:hover {
      background-color: #b5be00;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--spinnerBar.Active {
      position: absolute;
      width: 130px;
      height: 130px;
      margin-right: -20px;
      margin-top: -20px;
      border: 5px solid #b5be00;
      border-radius: 130px;
      opacity: 1;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer:hover {
    background-color: #ea7600;
  }
   .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer .HearingTest-test--playButton {
     text-align: center;
     position: absolute;
     width: 100px;
     height: 100px;
   }
   .HearingTest-test--calibrationContainer .HearingTest-test--spinner .HearingTest-test--playButtonContainer .HearingTest-test--volume {
     text-align: center;
     margin: 31px auto 0;
     font-weight: normal;
     font-style: normal;
     font-size: 44px;
     line-height: 44px;
     color: #fff;
   }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
      text-align: center;
      width: 100px;
      margin: 10px auto 0;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer .HearingTest-test--volumeControlContainer {
      text-align: center;
      opacity: 1;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer .HearingTest-test--volumeControlContainer .HearingTest-test--volumeControl {
      text-align: center;
      margin-bottom: 10px;
      font-size: 30px;
      line-height: 30px;
      color: #666;
      cursor: pointer;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer .HearingTest-test--volumeButton {
      text-align: center;
      margin-left: 0px;
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--volumeButton {
      text-align: center;
      cursor: pointer;
      background-color: #00b7c6;
      padding-top: 7px;
      padding-bottom: 7px;
      font-weight: normal;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
      color: #fff;
      -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
      -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--volumeButton:hover {
      background-color: #ea7600;
  }
  .HearingTest-test--textButton {
      text-align: center;
      display: inline-block;
      margin: 24px auto 0;
      font-weight: normal;
      font-style: normal;
      font-size: 30px;
      line-height: 30px;
      color: #00b7c6;
      cursor: pointer;
  }
</style>





// WEBPACK FOOTER //
// src/components/HearingTest/HearingCalibrationSpeaker.vue